import { Box, styled } from '@mui/material';

export const ViewOnlyAlertContainer = styled(Box)(
  ({ theme }) => `
    width: fit-content;
    height: fit-content;
    
    .MuiAlert-icon {
      color: ${theme.palette.primary.main};
      font-size: 22px;
    }
    
    .MuiAlert-message {
      font-weight: 500;
      text-wrap: nowrap;
    }
`,
);
